import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import Translator from "Languages/Utility/Translator";
import AccountService from "Services/http/endpoints/superadmin/AccountsEndpoints";
import * as Icons from "react-bootstrap-icons";
import BackDropLoading from "Components/BackDropLoading2/BackDropLoading";
import showNotify from "Helpers/Notify";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import { useTranslation } from "react-i18next";
import { getAccountingDefaultPanelAgain } from "Stores/actions";
import { useDispatch } from "react-redux";

export default function DeleteDefaultPanel({ row }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  const onShowDialog = () => {
    setShowDialog(true);
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        Id: row.Id,
      };
      const response = await AccountService.deleteAccountingDefaultPanel(
        params
      );
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch(getAccountingDefaultPanelAgain());
        showNotify({
          text: t("removed_successfully"),
          customClass: "success",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
    setLoading(false);
    setShowDialog(false);
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="deleteDefaultPanel" />}
        icon={<Icons.Trash3 />}
        onClick={onShowDialog}
        className="primary-button"
      />
      <BackDropLoading loading={loading} />
      <AlertDialog
        showAlert={showDialog}
        type="alertError"
        onClose={() => setShowDialog(false)}
        onClickOk={handleDelete}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
        exp={{
          periodName: row.Period,
          safd_Name: row.Name
        }}
      />
    </>
  );
}
